import { useContext, useCallback } from 'react';
import UserContext from 'user/UserContext';
import client from 'api/WookAxios';
import { AUTH_STATUS } from 'constants/auth';
import log from 'loglevel';

export const useAuth = () => {
  const { setUser, setAuthStatus } = useContext(UserContext);

  const syncAuth = useCallback(async () => {
    try {
      const response = await client.me();
      log.debug('SYNC_AUTH me', response);
      
      const data = response.data;
      setUser({
        id: data.id,
        username: data.username,
        name: data.name,
        email: data.email,
        mobile: data.mobile,
        allow_notice: data.allow_notice,
        profile_url: data.profile_url,
      });

      setAuthStatus(AUTH_STATUS.AUTHENTICATED);
    } catch(e) {
      log.debug('SYNC_AUTH_FAILED', e.response);
      setUser(null);
      setAuthStatus(AUTH_STATUS.UNAUTHENTICATED);
    }
  }, [setAuthStatus, setUser]);

  return { syncAuth };
};